import { Link } from "react-router-dom";
import { newsArticles } from "@/mocks/news";
import { movies } from "@/mocks/movies";
import SectionTitle from "@/components/base/SectionTitle";

export default function HotNews() {
  const hot = newsArticles.slice(0, 6);
  const picks = movies.slice(1, 4);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-shell px-4 py-12 md:px-6 md:py-16">
        <SectionTitle
          eyebrow="Newsroom"
          title="热门影视资讯"
          description="幕后花絮、修复动态与观影指南，按发布时间整理。"
          actionLabel="全部资讯"
          actionTo="/news"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {hot.map((article, index) => (
                <Link
                  key={article.id}
                  to={`/news/${article.id}`}
                  className="group flex items-start gap-4 border-b border-background-200 px-4 py-4 transition-colors last:border-b-0 hover:bg-background-100 md:px-5"
                >
                  <span
                    className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-label text-xs font-bold ${
                      index < 3
                        ? "bg-accent-500 text-background-50"
                        : "bg-background-200 text-foreground-500"
                    }`}
                  >
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="flex flex-wrap items-center gap-2">
                      <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-900">
                        {article.category}
                      </span>
                      <time className="font-label text-[11px] text-foreground-400">{article.date}</time>
                    </span>
                    <span className="mt-1.5 block clamp-2 font-heading text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-accent-600">
                      {article.title}
                    </span>
                  </span>
                  <i className="ri-arrow-right-up-line mt-1 shrink-0 text-foreground-300 transition-colors group-hover:text-accent-500" />
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <div className="mb-4 flex items-center justify-between">
                <h3 className="font-heading text-sm font-semibold text-foreground-950">本周编辑推荐</h3>
                <span className="font-label text-[10px] uppercase tracking-[0.18em] text-foreground-400">
                  Editor's Pick
                </span>
              </div>
              <div className="space-y-3">
                {picks.map((movie) => (
                  <Link
                    key={movie.id}
                    to={`/detail/${movie.id}`}
                    className="group flex gap-3 rounded-md border border-transparent p-2 transition-colors hover:border-background-200 hover:bg-background-100"
                  >
                    <div className="h-[84px] w-14 shrink-0 overflow-hidden rounded-md bg-background-200">
                      <img
                        src={movie.cover}
                        alt={`${movie.title} 影片封面`}
                        title={`${movie.title} · 编辑推荐`}
                        className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2">
                        <h4 className="truncate font-heading text-sm font-medium text-foreground-900">
                          {movie.title}
                        </h4>
                        <span className="flex shrink-0 items-center gap-0.5 font-label text-[11px] text-accent-600">
                          <i className="ri-star-fill text-[9px]" />
                          {movie.rating.toFixed(1)}
                        </span>
                      </div>
                      <p className="mt-1 text-[11px] text-foreground-500">
                        {movie.year} · {movie.type} · {movie.duration}
                      </p>
                      <p className="mt-1.5 clamp-2 text-[11px] leading-relaxed text-foreground-500">
                        {movie.summary}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
              <Link
                to="/category"
                className="mt-4 flex items-center justify-center gap-1 rounded-md bg-primary-50 py-2.5 text-xs text-primary-600 transition-colors hover:bg-primary-100"
              >
                浏览更多影片
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <div className="mt-4 rounded-lg border border-accent-200 bg-accent-50 p-4 md:p-5">
              <p className="flex items-center gap-2 font-heading text-sm font-semibold text-accent-900">
                <i className="ri-lightbulb-line text-accent-600" />
                观影小贴士
              </p>
              <p className="mt-2 text-xs leading-relaxed text-accent-900/80">
                本片信息量较大，建议在安静环境下完整观看。查看详情页的篇章式剧情介绍，可以帮助你在观影前理清人物关系。
              </p>
              <Link
                to="/detail/se-jie"
                className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-700 hover:text-accent-800"
              >
                查看剧情介绍
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}